import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {UsersSearch} from '../models/users-search.interface';
import {PageRequest} from '../../shared/models/page-request.interface';
import {Observable, throwError} from 'rxjs';
import {Page} from '../../shared/models/page.interface';
import {User} from '../../kf-data-entry/models/user.interface';
import {ApiHttpResponse} from '../../shared/models/api-http-response.interface';
import {catchError, map} from 'rxjs/operators';
import {Role} from '../models/role.interface';

const USERS_API = environment.apiUrl + 'users';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(private http: HttpClient) {
  }

  static buildSearchParams(search: UsersSearch): string {
    let searchParams = '';
    if (search.name && search.name !== '') {
      searchParams += `&name=${search.name}`;
    }
    if (search.firstName && search.firstName !== '') {
      searchParams += `&firstName=${search.firstName}`;
    }
    if (search.weeeSystem && search.weeeSystem !== '') {
      searchParams += `&weeeSystem=${search.weeeSystem}`;
    }
    if (search.role && search.role !== '') {
      searchParams += `&role=${search.role}`;
    }
    if (search.status) {
      searchParams += `&status=${search.status}`;
    }
    return searchParams;
  }

  getAll(search: UsersSearch, pageRequest: PageRequest = {page: 0, size: 100}): Observable<Page<User>> {
    let url = `${USERS_API}?size=${pageRequest.size}&page=${pageRequest.page}`;
    const searchParams = UsersService.buildSearchParams(search);
    if (pageRequest.sort && pageRequest.direction) {
      url = url + `&sort=${this.getSortCode(pageRequest.sort)},${pageRequest.direction}`;
    }
    return this.http.get<Page<User>>(url + searchParams);

  }

  getRoles(): Observable<Role[]> {
    return this.http.get<Role[]>(`${USERS_API}/roles`);
  }

  createUser(dto: User): Observable<ApiHttpResponse<User>> {
    return this.http.post<ApiHttpResponse<User>>(`${USERS_API}`, dto)
      .pipe(
        catchError(err => {
          return throwError(err);
        }),
        map((res: ApiHttpResponse<User>) => {
          return res;
        })
      );
  }

  editUser(dto: User): Observable<ApiHttpResponse<User>> {
    return this.http.put<ApiHttpResponse<User>>(`${USERS_API}`, dto)
      .pipe(
        catchError(err => {
          return throwError(err);
        }),
        map((res: ApiHttpResponse<User>) => {
          return res;
        })
      );
  }

  updateUser(id: number): Observable<ApiHttpResponse<User>> {
    return this.http.put<ApiHttpResponse<User>>(`${USERS_API}/update`, id)
      .pipe(
        catchError(err => {
          return throwError(err);
        }),
        map((res: ApiHttpResponse<User>) => {
          return res;
        })
      );
  }

  deleteUser(id: number): Observable<HttpResponse<any>> {
    return this.http.delete(`${USERS_API}/${id}`, {observe: 'response'})
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }

  printUsers(search: UsersSearch): Observable<any> {
    const url = `${USERS_API}/print?print=true`;
    const searchParams = search ? UsersService.buildSearchParams(search) : '';
    return this.http.get(url + searchParams, {
      observe: 'response',
      responseType: 'blob'
    });

  }

  private getSortCode(sort: string): string {
    switch (sort) {
      case 'open':
        return 'isReportingAvailable';
      default:
        return sort;
    }
  }
}
